import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid, MenuItem, Paper, TextField } from '@mui/material';
import { useParams } from 'react-router-dom';
import styles from './styles.module.css';
import withConsoleBase from '../../utils/ConsoleBase/withConsoleBase';
import { ShopContext } from '../../../Context/ShopContext';
import RestrictionInfo from '../../utils/Alert/RestrictionInfo';
import AlertHelper from '../../../helpers/AlertHelper';
import UserService from '../../../services/UserService';
import { SUBSCRIPTION_TYPE } from '../../../const';
import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Error from '../../utils/Alert/Error';
import Success from '../../utils/Alert/Success';

function UserPermissionDetail() {
  const { t: tCommon } = useTranslation('common');
  const { t: tManagement } = useTranslation('management');
  const { id } = useParams();
  const { shop } = useContext(ShopContext);
  const subscriptionType = shop?.subscription?.type;
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [userDetail, setUserDetail] = useState('');
  const [permissions, setPermissions] = useState({
    id: null,
    shop: null,
    user: null,
    username: '',
    customers_permission: '',
    damage_permission: '',
    devices_permission: '',
    products_permission: '',
    purchase_permission: '',
    reports_permission: '',
    shop_permission: '',
    stock_permission: '',
    users_permission: '',
    expense_permission: '',
  });
  const handlePermissionChange = (e) =>
    setPermissions({
      ...permissions,
      [e.target.name]: e.target.value,
    });
  useEffect(() => {
    if (subscriptionType && subscriptionType !== SUBSCRIPTION_TYPE.BASIC) {
      loadUserDetail();
    }
    // eslint-disable-next-line
  }, [subscriptionType]);

  const loadUserDetail = async () => {
    setLoadingIndicator(true);
    try {
      const userDetail = await UserService.getShopUserDetailsAndPermissions(id);
      setUserDetail(userDetail);
      setPermissions(userDetail.shop_permissions);
    } catch (err) {
      AlertHelper.setShortMessage(setErrorMsg, err.message);
    }
    setLoadingIndicator(false);
  };
  const updateBtnPressed = async () => {
    try {
      await UserService.UpdateUserPermissions(permissions, id);
      AlertHelper.setShortMessage(setSuccessMsg, tManagement('Updated user permission successfully'));
    } catch (error) {
      AlertHelper.setShortMessage(setErrorMsg, error.message);
    }
  };
  return (
    <>
      <div className={styles.contentLayoutColumn}>
        <div className={styles.headingDiv}>
          <span className={styles.pageHead}>Detailed User Permissions</span>
        </div>
        {subscriptionType && subscriptionType === SUBSCRIPTION_TYPE.BASIC && (
          <RestrictionInfo title={tCommon('Feature not available')} content={tCommon('To get stock report options upgrade subscription to premium')} />
        )}
        {subscriptionType && subscriptionType !== SUBSCRIPTION_TYPE.BASIC && (
          <>
            <div className={styles.changeable}>
              <div style={{ padding: 15 }}>
                <span className={styles.pageHead}>{tCommon('User Details')}</span>
              </div>
              <Grid container spacing={1} className={styles.userDetailDiv}>
                <Paper className={styles.userBox}>
                  <div className={styles.userCard}>
                    <span className={styles.fieldTitleSmall}>{tCommon('First Name')} :</span>
                    <span className={styles.fieldTitle}>{loadingIndicator ? <Skeleton variant="text" width={100} animation="wave" /> : userDetail.first_name}</span>
                  </div>
                </Paper>
                <Paper className={styles.userBox}>
                  <div className={styles.userCard}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Last Name')} :</span>
                    <span className={styles.fieldTitle}>{loadingIndicator ? <Skeleton variant="text" width={100} animation="wave" /> : userDetail.last_name}</span>
                  </div>
                </Paper>
                <Paper className={styles.userBox}>
                  <div className={styles.userCard}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Username')} :</span>
                    <span className={styles.fieldTitle}>{loadingIndicator ? <Skeleton variant="text" width={100} animation="wave" /> : userDetail.username}</span>
                  </div>
                </Paper>
              </Grid>
              {errorMsg && (
                <div className={styles.padding15}>
                  <Error title={errorMsg} />
                </div>
              )}
              {successMsg && (
                <div className={styles.padding15}>
                  <Success title={successMsg} />
                </div>
              )}
              <Grid container spacing={1} style={{ padding: 15, paddingTop: 30 }}>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead} style={{ marginBottom: 15 }}>
                    <span className={styles.pageHead}>{tCommon('Permissions')}</span>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Products Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="products_permission"
                      value={permissions.products_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Devices Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="devices_permission"
                      value={permissions.devices_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Customers Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="customers_permission"
                      value={permissions.customers_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Purchase Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="purchase_permission"
                      value={permissions.purchase_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Damage Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="damage_permission"
                      value={permissions.damage_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Stock Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="stock_permission"
                      value={permissions.stock_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Reports Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="reports_permission"
                      value={permissions.reports_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Generate Reports')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Shop Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="shop_permission"
                      value={permissions.shop_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Users Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="users_permission"
                      value={permissions.users_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={6} sm={12} className={styles.BillHeader}>
                  <div className={styles.fieldHead}>
                    <span className={styles.fieldTitleSmall}>{tCommon('Expense Permission')}</span>
                  </div>
                  <div className={styles.fieldInput}>
                    <TextField
                      select
                      style={{ minWidth: 200 }}
                      size="small"
                      name="expense_permission"
                      value={permissions.expense_permission}
                      variant="outlined"
                      color="primary"
                      onChange={handlePermissionChange}
                    >
                      <MenuItem value={'deny'}>{tCommon('No Permission')}</MenuItem>
                      <MenuItem value={'read'}>{tCommon('Read Permission')}</MenuItem>
                      <MenuItem value={'write'}>{tCommon('Write Permission')}</MenuItem>
                    </TextField>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={1} style={{ marginTop: 4, marginBottom: 4, padding: 15 }}>
                <Grid item xs={6} sm={12}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={updateBtnPressed}
                    color="secondary"
                    style={{ backgroundColor: '#00a65a' }}
                  >
                    {tCommon('Update Permissions')}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default withConsoleBase(UserPermissionDetail);
